import React, { useState, useEffect } from 'react';
import { Select, Popconfirm, Badge, Drawer, Modal, Button, List, Tag, Row, Col, Empty, Icon, Spin, message } from "antd";
import { useMappedState } from 'redux-react-hook';
import { saveResume, getCandidates, getEfinancialResumeDownload, getSavedJobById, getEfinancialResumeViewById } from './../API';
import parse from 'html-react-parser';
import moment from 'moment';
import { format } from 'timeago.js';
import { PROVIDER, refGenerator } from './../utils';

const { uniqBy, sortBy, orderBy, groupBy } = require('lodash');
const { Option } = Select;

const buildSnippets = (string) => {
  let text = string.replace(/<endeca_term>/g, '<b style="background-color: #FFFF00">');
  text = text.replace(/<\/endeca_term>/g, '</b>');
  text = text.replace(/<US\$/g, '(US$');
  return text;
}

const generateDriveURL = (entry, cvFileId) => {
  if (entry) {
    if (entry.originalFileName.includes('pdf')) {
      return `https://drive.google.com/file/d/${cvFileId}/preview`;
    } else {
      return `https://docs.google.com/document/d/${cvFileId}/`;
    }
  }
  return null;
}

const generateResumeCombinedId = (provider, id) => {
  return `${provider}-${id}`;
}

function SavedJob({id}) {
  const session = useMappedState(state => state.session);
  const app = useMappedState((state) => state.app);

  const [loading, setLoading] = useState(true);
  const [resumes, setResumes] = useState([]);

  const [entry, setEntry] = useState(null);
  const [showResume, setShowResume] = useState(null);

  const [openDrawer, setOpenDrawer] = useState(false);

  const [resumeLoading, setResumeLoading] = useState(false);
  const [cvFileId, setCvFileId] = useState(null);

  const [candidateCount, setCandidateCount] = useState(null); // this is for generate new candidate ref
  const [saveLoading, setSaveLoading] = useState(false);

  const [savedResumeIds, setSavedResumeIds] = useState([]); // this is for efinancial only at moment

  const [expArr, setExpArr] = useState([]);
  const [searchExp, setSearchExp] = useState('All');

  const [secArr, setSecArr] = useState([]);
  const [searchSec, setSearchSec] = useState('All');

  const [locArr, setLocArr] = useState([]);
  const [searchLoc, setSearchLoc] = useState('All');

  useEffect(() => {
    async function fetchData() {
      const dataResponse = await Promise.all([
        getSavedJobById(session.authToken, id),
        getCandidates(session.authToken),
      ]);
      setResumes(dataResponse[0].data.data.resumeData);
      setCandidateCount(dataResponse[1].data.candidates.length);
      setSavedResumeIds(dataResponse[1].data.candidates.filter((i) =>
                        i.systemGenerateSource === PROVIDER.EFINANCIAL).map((e) => generateResumeCombinedId(PROVIDER.EFINANCIAL, e.systemGenerateSourceId)));

      const groupExperience = groupBy(dataResponse[0].data.data.resumeData, 'experience');
      let expArr = Object.keys(groupExperience).map(e => {
        return e
      });
      expArr = sortBy(expArr, (e) => {
        const rank = {
          "1-3 yrs"   : 1,
          "3-5 yrs"   : 2,
          "5-7 yrs"   : 3,
          "7-10 yrs"  : 4,
          "10-15 yrs" : 5,
          "15+ yrs"   : 6,
          "null"      : 7
        };

        return rank[e];
      })
      setExpArr(expArr);

      const groupSector = groupBy(dataResponse[0].data.data.resumeData, 'meta.sector');
      const secArr = Object.keys(groupSector).map(e => {
        return e
      });
      setSecArr(sortBy(secArr));

      const groupLocation = groupBy(dataResponse[0].data.data.resumeData, 'location');
      let locArr = Object.keys(groupLocation).map(e => {
        return e
      });
      locArr = locArr.map((i) => {
        return i.split(' > ')[0]
      })
      setLocArr(sortBy(uniqBy(locArr)));

      setLoading(false);
    }
    fetchData();
  // eslint-disable-next-line
  }, []);

  const buildItem = (item) => {
    switch(item.provider) {
      case PROVIDER.EFINANCIAL:
        return buildEfinancialItem(item);
      default:
        return null;
    }
  }

  const buildEntryContent = (entry) => {
    switch(entry.provider) {
      case PROVIDER.EFINANCIAL:
        return buildEfinancialEntryContent(entry);
      default:
        return null;
    }
  }

  const buildEfinancialEntryContent = (entry) => {
    return (
      <div>
        {
          entry.contactDetails ? (
            <div>
              <span>Name:</span>&nbsp;<b>{entry.contactDetails.title} {entry.contactDetails.fullName}</b><br/>
              <span>Email:</span>&nbsp;<b>{entry.contactDetails.email}</b><br/>
              <span>Phone:</span>&nbsp;<b>{entry.contactDetails.phone}</b><br/>
              <span>Location:</span>&nbsp;<b>{entry.location.name}</b><br/>
            </div>
          ) : (
            <div>
              No contact details found for this resume, Please re-input contact details if you saved this resume.
            </div>
          )
        }
        <br />
        <Button type="primary" onClick={() => {
          setOpenDrawer(true);
        }}>
          Open CV Preview
        </Button>
      </div>
    )
  }

  const buildEfinancialItem = (item) => {
    return(
      <Row style={{
        paddingLeft: '5px',
        paddingRight: '5px',
      }}>
        <Col span={5}>
          <Tag color="#FF8C00"><b>{item.location ? item.location : 'N/A'}</b></Tag>
          <br />
          <br />
          <Tag color="#B284BE"><b>{item.experience ? item.experience : 'N/A'}</b></Tag>
          <br />
          <br />
          <b>{item.meta ? item.meta.sector : null}</b>
        </Col>
        <Col span={4}>
          {
            item.meta && item.meta.languageLevels.map((i) => (
              <div key={i.name}>
                <Tag><b>{i.name}</b></Tag> <span>{i.level}</span>
              </div>
            ))
          }
          <br />
          {
            item.meta && item.meta.salary ? (
              <div>
                <b>{item.meta.salary.desiredSalary} / {item.meta.salary.salaryCurrencyCode}</b>
              </div>
            ) : null
          }
        </Col>
        <Col span={15}>
          <div>
          <b>{item.title}</b>
          &nbsp;&nbsp;
          <Badge count={item.updateCount}>
            <Popconfirm
              disabled={savedResumeIds.includes(generateResumeCombinedId(item.provider, item.id))}
              placement="left"
              title="Are you sure to open this resume view?"
              onConfirm={async () => {
                setShowResume(true);
                setResumeLoading(true);

                /***
                 *
                 * testing resume id: 11900239 (doc) / 12150677 (pdf)
                 * TODO: change item.id
                 */
                const result = await getEfinancialResumeViewById(session.authToken, item.id);

                if (result.data.responseCode === 0) {
                  setEntry({
                    ...result.data.data,
                    ...{
                      provider: item.provider
                    }
                  });

                  const download = await getEfinancialResumeDownload(
                    session.authToken,
                    {
                      link: result.data.data.downloadLink,
                      token: result.data.token,
                      fileName: result.data.data.originalFileName
                    });

                  if (download.data.responseCode === 0) {
                    setCvFileId(download.data.data.id);
                  } else {
                    message.error(download.data.message);
                    setShowResume(false);
                    setEntry(null);
                  }
                } else {
                  message.error(result.data.message);
                  setShowResume(false);
                }
                setTimeout(() => {
                  setResumeLoading(false);
                }, 150);
              }}
              okText="Yes"
              cancelText="No"
            >
              <Button disabled={savedResumeIds.includes(generateResumeCombinedId(item.provider, item.id))} type="primary" size="small">
                Resume View
              </Button>
            </Popconfirm>
          </Badge>
          &nbsp;&nbsp;
            {
              todayIDs.includes(item._id) ? (
                <Badge color='pink' dot>
                  <i>posted&nbsp;{format(new Date(moment(item.updateDate).format('YYYY-MM-DD HH:mm:ss')))}</i>
                </Badge>
              ) : (
                <i>posted&nbsp;{format(new Date(moment(item.updateDate).format('YYYY-MM-DD HH:mm:ss')))}</i>
              )
            }
          </div>
          <br />
          <div>
          {
            item.meta && item.meta.snippets.map((i) => (
              <div key={i.snippetName}>{parse(buildSnippets(i.snippetValue))}</div>
            ))
          }
          </div>
        </Col>
      </Row>
    )
  }

  const resumeTodayData = app.resumeReminder.map((i) => {
    return {
      ...i,
      ...{
        data: i.data.filter(
          (i) => moment(i.createdAt).isSame(moment(), 'day') &&
          i.status === 'success'
        )
      }
    }
  });
  const ops = [];
  for (const each of resumeTodayData) {
    for (const every of each.data) {
      const foundResumes = resumes.filter((i) => i.provider === every.provider && i.savedJob === every.savedJob)
                           .filter((e) => every.meta.newResumes.includes(e.id));
      ops.push(foundResumes.map((i) => i._id))
    }
  }
  const todayIDs = ops.flat();

  let listResumesData = orderBy(resumes, ['updateCount', 'updateDate'], ['desc', 'desc']);

  if (searchLoc !== 'All') {
    listResumesData = listResumesData.filter((i) => i.location.includes(searchLoc));
  }

  if (searchExp !== 'All') {
    if (searchExp !== 'null') {
      listResumesData = listResumesData.filter((i) => i.experience === searchExp);
    } else {
      listResumesData = listResumesData.filter((i) => i.experience === null);
    }
  }

  if (searchSec !== 'All') {
    listResumesData = listResumesData.filter((i) => i.meta.sector === searchSec);
  }

  const dotJobs = listResumesData.filter((i) => todayIDs.includes(i._id));
  const notDotJobs = listResumesData.filter((i) => !todayIDs.includes(i._id));

  listResumesData = [...dotJobs, ...notDotJobs];

  return (
    loading ?
    <center>
      <Spin spinning={loading} indicator={<Icon type="loading" />} />&nbsp;&nbsp;Loading...
    </center>
    :
    <div>
      <Drawer
        title="CV Preview"
        placement="right"
        width={1024}
        visible={openDrawer}
        onClose={() => {
          setOpenDrawer(false);
        }}
      >
        <iframe
          title="cv" src={generateDriveURL(entry, cvFileId)}
          style={{width: '100%', height: '1000px', border: 0}}
        ></iframe>
      </Drawer>
      <Modal
        width="80%"
        centered={true}
        title={<div>
          <Row>
            <Col span={12}>
              Resume View
            </Col>
          </Row>
        </div>}
        closable={false}
        visible={showResume}
        footer={[
          <Button disabled={resumeLoading || saveLoading} key="cancel" onClick={() => {
            setShowResume(false);
            setTimeout(() => {
              setEntry(null);
              setCvFileId(null);
            }, 150);
          }}>
            <Icon type="close" />
            Close
          </Button>,
          <Button disabled={resumeLoading || saveLoading} type="primary" key="save" onClick={async () => {
            // TODO: separate save function by provider,
            // below is only for save candidate from efinancial
            setSaveLoading(true);
            let params;
            if (entry.contactDetails) {
              const name = entry.contactDetails.fullName.replace(/\s\s+/g, ' ').trim().split(' ');
              params = {
                reference: refGenerator('candidate', candidateCount),
                salutation: entry.contactDetails.title ? entry.contactDetails.title : '',
                firstname: name[0],
                lastname: name[1],
                email: entry.contactDetails.email,
                mobile: entry.contactDetails.phone ? entry.contactDetails.phone : '',
                location: entry.location.name ? entry.location.name : 'N/A',
                source: PROVIDER.EFINANCIAL,
                sourceId: entry.id,
                fileId: cvFileId,
              };
            } else {
              params = {
                reference: refGenerator('candidate', candidateCount),
                salutation: '',
                firstname: 'unknown',
                lastname: 'unknown',
                email: 'unknown@unknown.com',
                mobile: '',
                location: 'N/A',
                source: PROVIDER.EFINANCIAL,
                sourceId: entry.id,
                fileId: cvFileId,
              };
            }

            const result = await saveResume(session.authToken, params);
            if (result.data.responseCode === 0) {

              /**
               * need to update candidates count and savedResumeIds
               */
              const data = await getCandidates(session.authToken);
              setCandidateCount(data.data.candidates.length);
              setSavedResumeIds(data.data.candidates.filter((i) =>
                                i.systemGenerateSource === PROVIDER.EFINANCIAL).map((e) => generateResumeCombinedId(PROVIDER.EFINANCIAL, e.systemGenerateSourceId)));

              message.success(result.data.message);
              setShowResume(false);
              setTimeout(() => {
                setEntry(null);
                setCvFileId(null);
              }, 150);
            } else {
              message.error(result.data.message);
            }
            setSaveLoading(false);
          }}>
            {
              saveLoading ? <Icon type="loading" /> : <Icon type="save" />
            }
            Save
          </Button>
        ]}
      >
        <div>
          {
            resumeLoading ? (
              <center><Spin spinning={resumeLoading} indicator={<Icon type="loading" />} />&nbsp;&nbsp;Loading Resume...</center>
            ) : (
              <div>
                {
                  entry ? (
                    <div>
                      {buildEntryContent(entry)}
                    </div>
                  ) : null
                }
              </div>
            )
          }
        </div>
      </Modal>
      <Row>
        <Col span={20}>
          <div>
            Job Seeker Location:
            &nbsp;&nbsp;
            <Select
              defaultValue={'All'}
              placeholder="Select Location"
              style={{ width: '225px' }}
              onChange={(value) => {
                setSearchLoc(value);
              }}
            >
              {
                [...['All'], ...locArr].map((i) => (
                  <Option key={i} value={i}>
                    {i}
                  </Option>
                ))
              }
            </Select>
            &nbsp;&nbsp;
            Experience:
            &nbsp;&nbsp;
            <Select
              defaultValue={'All'}
              placeholder="Select Experience"
              style={{ width: '225px' }}
              onChange={(value) => {
                setSearchExp(value);
              }}
            >
              {
                [...['All'], ...expArr].map((i) => (
                  <Option key={i} value={i}>
                    {i}
                  </Option>
                ))
              }
            </Select>
            &nbsp;&nbsp;
            Sector:
            &nbsp;&nbsp;
            <Select
              defaultValue={'All'}
              placeholder="Select Sector"
              style={{ width: '225px' }}
              onChange={(value) => {
                setSearchSec(value);
              }}
            >
              {
                [...['All'], ...secArr].map((i) => (
                  <Option key={i} value={i}>
                    {i}
                  </Option>
                ))
              }
            </Select>
          </div>
        </Col>
      </Row>
      <br />
      {resumes.length > 0 ? (
        <List
          style={{
            maxHeight: "390px",
            overflow: "auto"
          }}
          itemLayout="vertical"
          size="large"
          pagination={{
            pageSize: 100,
          }}
          dataSource={listResumesData}
          renderItem={item => (
            <List.Item key={item._id}>
              {buildItem(item)}
            </List.Item>
          )}
        />
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      )}
    </div>
  )
}

export default SavedJob;
